module.exports = __webpack_public_path__ + "static/main2phones-f0ee5b9bb2a46fd47dffe94a291ce308.png";